import React, { forwardRef } from 'react';
import AddBox from '@material-ui/icons/AddBox';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Print from '@material-ui/icons/Print';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';

export const defaultRequestColumns = [{ "Label": "Date submitted", "Optional": false, "Active": true, "Dataview": false, "DataviewKey": "DEFAULT__DATE" },
{ "Label": "Date requested", "Optional": false, "Active": true, "Dataview": false, "DataviewKey": "DEFAULT__DATE_REQUESTED" },
{ "Label": "Request type", "Optional": false, "Active": true, "Dataview": false, "DataviewKey": "DEFAULT__REQUEST_TYPE" },
{ "Label": "Status", "Optional": false, "Active": true, "Dataview": false, "DataviewKey": "DEFAULT__STATUS" },
{ "Label": "Warning", "Optional": true, "Active": true, "Dataview": false, "DataviewKey": "DEFAULT__WARNING" },
{ "Label": "Modified by", "Optional": true, "Active": true, "Dataview": false, "DataviewKey": "DEFAULT__APPROVE_BY" }];

export const defaultEmployeeColumnsLeft = [{ "Label": "Employee Name", "Optional": false, "Active": true, "Dataview": false, "DataviewKey": "DEFAULT__EMPLOYEE_NAME" }];
export const defaultEmployeeColumnsRight = [{ "Label": "Shift", "Optional": false, "Active": true, "Dataview": false, "DataviewKey": "DEFAULT__SHIFT" }];

export const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    Print: forwardRef((props, ref) => <Print {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowUpward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};